import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'
import { Tooltip } from 'core-components/library/tooltip'

import { ESP_TRANSLATION_KEYS } from '../../../configs/translations'
import { IEspRequest } from '../../../model/types'
import { EspBadge } from '../../espBadge/EspBadge'
import styles from '../EspAdminRequestsPanel.module.scss'

import { REQUEST_STATUS_LABEL_KEYS, REQUEST_STATUS_TO_BADGE } from './requestStatusBadge'

const KEYS = ESP_TRANSLATION_KEYS.admin

export const getColumns = (selectedRequestId: string | null): IColumn<IEspRequest>[] => [
  {
    field: 'partnerId',
    title: KEYS.columnPartner,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnPartner} />,
    renderFunction: (item) => (
      <div className={styles.partnerCell}>
        {/* Hidden marker the row-level `:has()` rule paints the selection from. */}
        {item.id === selectedRequestId ? <span className={styles.selectedRowMarker} /> : null}
        <div className={styles.partnerName}>{item.accountInfo.partnerName}</div>
        <div className={styles.partnerId}>{item.partnerId}</div>
      </div>
    ),
  },
  {
    field: 'type',
    title: KEYS.columnType,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnType} />,
    renderFunction: (item) => (
      <span className={styles.typeCell}>
        <Translation text={item.type === 'change' ? KEYS.typeChange : KEYS.typeEnrollment} span />
        {item.justification ? (
          <Tooltip tipContent={() => <>{item.justification}</>}>
            <i className="kbase kbase-info-alt" />
          </Tooltip>
        ) : null}
      </span>
    ),
  },
  {
    field: 'sponsor',
    title: KEYS.columnSponsor,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnSponsor} />,
    renderFunction: ({ sponsor }) => (
      <span>
        <span>{sponsor.name}</span>
        {sponsor.email ? <span className={styles.sponsorTitle}> · {sponsor.email}</span> : null}
      </span>
    ),
  },
  {
    field: 'requestedBy',
    title: KEYS.columnRequestedBy,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnRequestedBy} />,
    renderFunction: (item) => <>{item.requestedBy || '—'}</>,
  },
  {
    field: 'createdAt',
    title: KEYS.columnSubmitted,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnSubmitted} />,
    renderFunction: (item) => <>{new Date(item.createdAt).toLocaleDateString()}</>,
  },
  {
    field: 'status',
    title: KEYS.columnStatus,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnStatus} />,
    renderFunction: (item) => (
      <span className={styles.statusCell}>
        <EspBadge
          variant={REQUEST_STATUS_TO_BADGE[item.status]}
          labelKey={REQUEST_STATUS_LABEL_KEYS[item.status]}
        />
        {item.rejectionReason ? (
          <Tooltip tipContent={() => <>{item.rejectionReason}</>}>
            <i className="kbase kbase-info-alt" />
          </Tooltip>
        ) : null}
      </span>
    ),
  },
]
